import React, { useState } from 'react';
import { TypographyStyledBlack } from '../../../../shared/components/tileLinkStyled/style';
import { Box, Typography, Modal, Button, Container } from '@mui/material';
import { BlueHeaderWithText } from '../../../estimatingRequirements/peng2018/blueHeaderWithText';
import { metaDataSelector } from '../../../../store/globalSelectors';
import { useAppSelector } from '../../../../store/hooks';
import { NavigationButtons } from '../../../../shared/components/navigationButtons';
import { Tooltip } from '../../../../shared/components/toolTip/';

import InfoIcon from '../../../../assets/icons/infoIcon.svg';
import ScreeningResultsIcon from '../../../../assets/icons/screeningResultsIcon.svg';

export const MSTScreeningResult = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    malnutritionScreening,
    optedOptions: { routeArr }
  } = useAppSelector(metaDataSelector);
  const { mst } = malnutritionScreening;
  const { totalScore } = mst;

  let domElement;
  if (totalScore >= 2) {
    domElement = (
      <div>
        {`MST score ≥2 may indicate `}
        <strong>patient is at risk of malnutrition.</strong>
      </div>
    );
  } else {
    domElement = (
      <div>
        {`MST score <2 may indicate `}
        <strong>patient is not at risk of malnutrition.</strong>
      </div>
    );
  }

  const getNextRoute = () => {
    if (routeArr.length) return routeArr[0];
    else return '/summary';
  };

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          backgroundColor: '#F2F2F2',
          p: 0,
          top: 0,
          left: 0
        }}
      >
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0px',
            justifyContent: 'flex-end',
            margin: '0px'
          }}
        >
          <Button
            onClick={handleOpen}
            sx={{
              height: '1.25rem',
              minWidth: '1.25rem',
              padding: '0px',
              marginTop: '1.875rem'
            }}
          >
            <img src={InfoIcon} alt={'Info'} />
          </Button>
        </Container>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              height: '100px',
              width: '100px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img alt="Screening Result Icon" src={ScreeningResultsIcon} />
          </Box>

          <TypographyStyledBlack sx={{ margin: '3.125rem 0' }}>
            SCREENING RESULTS
          </TypographyStyledBlack>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <BlueHeaderWithText
              text1={'MST Score:'}
              value1={String(totalScore)}
              single={true}
              customWidth="90%"
            />
          </Box>
        </Box>
        <div>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1.875rem'
            }}
          >
            <Box
              sx={{
                width: '80%',
                backgroundColor: '#fff',
                border: '0.125rem solid #002A3A',
                borderRadius: '0.9375rem',
                padding: '0.9375rem'
              }}
            >
              {domElement}
            </Box>
          </Box>
        </div>
      </Box>

      <NavigationButtons nextRoute={getNextRoute()} nextDisabled={false} />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Tooltip
          onClose={handleClose}
          title={'Reference:'}
          content={
            <Typography
              align="left"
              sx={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: '1.25rem',
                color: '#004F71'
              }}
            >
              Ferguson, M
              <span style={{ fontFamily: 'CalibriItalic' }}> et al.</span> Clin
              Nutrition 1999 15:458-464.
            </Typography>
          }
        />
      </Modal>
    </>
  );
};
